import React, { useState } from "react";
import { TableCell, TableRow, IconButton } from "@mui/material";
import { faAngleDown, faAngleUp } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import RoleListRowSummary from "../../../components/UserManagement/Roles/RoleListSummary";
import HotelListSummary from "./HotelListSummary";
import CdsnDetailssummary from "./CdsnDetailssummary";

const Row = (props) => {
  const { row, ...rest } = props;
  const [open, setOpen] = useState(false);

  return (
    <>
      <TableRow>
        {props.columns.map((col) => {
          return (
            <TableCell
              key={col.field}
              style={{
                paddingLeft: "10px",
                paddingRight: 0,
                whiteSpace: "nowrap",
              }}
            >
              {col.renderCell !== undefined
                ? col.renderCell(
                  col.row ? row : row[col.field],
                  props.pageOptions
                )
                : row[col.field]}
            </TableCell>
          );
        })}
        {props.module ? (
          <TableCell>
            <IconButton
              aria-label="expand row"
              size="small"
              onClick={(e) => { e.stopPropagation(); setOpen(!open) }}
            >
              {open ? <FontAwesomeIcon icon={faAngleUp} /> : <FontAwesomeIcon icon={faAngleDown} />}
            </IconButton>
          </TableCell>
        ) : (
          <TableCell></TableCell>
        )}
      </TableRow>
      {
        (props.module === 'rolesList' || props.module === 'userList') && <RoleListRowSummary row={row} columns={props.columns} open={open} module={props.module} {...rest} />
      }
      {
        (props.module === 'default' || props.module === 'hotel-config' || props.module==="room-config" || props.module==="publish-unpublish" || props.module==="banner-config" || props?.module==="customize-welcome-screen" || props?.module==="group-room" || props?.module==="partner-config" || props?.module==="stack-details") && <HotelListSummary row={row} columns={props.columns} open={open} module={props.module} {...rest} />
      }
      {
        (props?.module === "cdsndetails-welcomescreen") && <CdsnDetailssummary row={row} columns={props.columns} open={open} module={props.module} {...rest} />
      }
    </>
  );
};

export default Row;
